<div class="h-100" *transloco="let t;lang: sharedUiService.currentActiveLanguage?.id">
<router-outlet></router-outlet>
</div>
